import React from "react";

const Loader = ({ isFullPage = true }: { isFullPage?: boolean }) => {
    return (
        <div id="pageLoader">
            <div id="preloader" style={{ position: isFullPage ? "fixed" : "inherit" }}>
                <div id="status">
                    <div className="spinner">
                        <div className="double-bounce1"></div>
                        <div className="double-bounce2"></div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default Loader;
